import { LocationProvider, Router, Route } from 'preact-iso';
import { Landing } from './pages/Landing';
import { Changelog } from './pages/Changelog';
import { NotFound } from './pages/NotFound';
import { SignIn } from './pages/SignIn';
import { AuthCallback } from './pages/AuthCallback';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { Support } from './pages/Support';
import { DeleteAccount } from './pages/DeleteAccount';
import { LinkInvite } from './pages/LinkInvite';
import { Dashboard } from './pages/app/Dashboard';
import { AdminUsers } from './pages/admin/AdminUsers';
import { AdminSubscriptions } from './pages/admin/AdminSubscriptions';
import { AdminAIUsage } from './pages/admin/AdminAIUsage';
import { AdminAnnouncements } from './pages/admin/AdminAnnouncements';

export function App() {
  return (
    <LocationProvider>
      <Router>
        <Route path="/" component={Landing} />
        <Route path="/changelog" component={Changelog} />
        <Route path="/auth" component={SignIn} />
        <Route path="/auth/callback" component={AuthCallback} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/terms" component={Terms} />
        <Route path="/support" component={Support} />
        <Route path="/delete-account" component={DeleteAccount} />
        {/* Public invite target — the code is redeemed in the app, not here. */}
        <Route path="/link/:code" component={LinkInvite} />
        <Route path="/app" component={Dashboard} />
        <Route path="/admin" component={AdminUsers} />
        <Route path="/admin/users" component={AdminUsers} />
        <Route path="/admin/subscriptions" component={AdminSubscriptions} />
        <Route path="/admin/ai" component={AdminAIUsage} />
        <Route path="/admin/announcements" component={AdminAnnouncements} />
        {/* Keep in step with spaRoute() in backend/internal/http/server.go. */}
        <Route default component={NotFound} />
      </Router>
    </LocationProvider>
  );
}
